// run by gatsby-config.js as well
const theme = require('gatsby-theme-nodust/src/layouts/theme');

module.exports = () => ({
  ...theme(),
});
